/**
 * Serialises a schema.org graph for `<script type="application/ld+json">`, leaving out every
 * property and array entry that is `null` or `undefined`.
 *
 * A restaurant without a phone number, a product without a description or a company without a
 * currency used to come out as `"telephone": null` and friends. Schema.org has no meaning for a
 * null value, and Safari's own JSON-LD reader (`extractSchemaValuesFromJSONLD`, injected into the
 * page) walks every object-typed value and crashes on `null`, since `typeof null === 'object'`:
 * "null is not an object (evaluating 'Object.prototype.hasOwnProperty.call(o,"telephone")')",
 * FOODAMIGOS-SHOP-WEB-29C. An absent property says the same thing and is safe to walk.
 */
export function toJsonLd(schema: unknown): string {
  return JSON.stringify(withoutEmptyValues(schema));
}

function withoutEmptyValues(value: unknown): unknown {
  if (Array.isArray(value)) {
    return value.filter((item) => item !== null && item !== undefined).map(withoutEmptyValues);
  }

  if (value !== null && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value)
        .filter(([, item]) => item !== null && item !== undefined)
        .map(([key, item]) => [key, withoutEmptyValues(item)]),
    );
  }

  return value;
}
